import type { TabContent } from '../../components/PageConfigProvider/page-reducer';
import { getReportBrandLogos } from './report-brand-logos';

export function getReportDefaultItems(
  clientName?: string | null
): TabContent['items'] {
  const { logoImage, clientLogos } = getReportBrandLogos(clientName);

  const coverPageLogo: TabContent['items'] = [
    {
      id: 'cover-page-icon',
      title: '',
      position: { x: 0, y: 1, width: 10, height: 2 },
      plot: {
        chartType: 'image',
        imageSrc: logoImage,
      },
    },
  ];

  return [
    ...(clientName !== 'default' ? coverPageLogo : []),
    {
      position: { x: 0, y: 75, width: 35, height: 14 },
      id: '8e8e9c53-a683-4b65-a60b-ce204a895488',
      title: '',
      plot: {
        chartType: 'text',
        textHtml:
          "### About Revelio Labs data\n\nRevelio Labs provides workforce intelligence. We absorb and standardize hundreds of millions of public employment records to create the world's first universal HR database, allowing us to see current workforce composition of any company. We use the most advanced techniques in data science and statistical modeling to provide clean, reliable workforce data, which we additionally enrich with our proprietary models for greater insight into workforce trends. With our salary prediction model, we are able to estimate salaries for more than 1.4 billion unique positions worldwide, using individual-level information such as job title, seniority level, company, and location.",
        excludeFromExecutiveSummary: true,
      },
    },
    {
      position: { x: 0, y: 89, width: 25, height: 14 },
      id: '03637da7-3c99-4f00-a338-37cee9b148c8',
      title: '',
      plot: {
        chartType: 'text',
        textHtml:
          '## Contact\nThank you for your interest in our data.\n\nBy ingesting the universe of publicly available online profiles, job postings, employee sentiment reviews, and layoff notices, Revelio Labs has created a comprehensive source of workforce data that can be used to analyze companies, occupations, skills, and activities. In addition to attrition, our team of labor economists and data scientists can create customized reports on industry outlooks, talent intelligence, DEI, and more.\n\nFor additional information on the custom insights we can offer, please reach out to [info@reveliolabs.com](mailto:info@reveliolabs.com)',
        excludeFromExecutiveSummary: true,
      },
    },
    {
      position: { x: 26, y: 92, width: 21, height: 11 },
      id: '66eea1d2-f38f-42fd-985c-3407a3a7a7b6',
      title: '',
      plot: {
        chartType: 'text',
        textHtml:
          '#### Get in touch\nReach out for additional information on the custom insights we can offer.\n#### Email us\ninfo@reveliolabs.com\n#### Visit us\n860 Broadway, 5th floor, New York, NY 10003',
        excludeFromExecutiveSummary: true,
      },
    },
    {
      id: 'footer-page-icon',
      title: '',
      position: { x: 36, y: 76, width: 11, height: 11 },
      plot: {
        chartType: 'image',
        imageSrc: clientLogos,
      },
    },
  ];
}
